import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

//
import IconWrapper from "../../../components/icon-wrapper/IconWrapper";
import ImageOverlayCard from "../../../components/image-overlay-card/ImageOverlayCard";

export default function EyeDiseaseTemplate({
  title,
  text,
  img,
  list = [],
  reverse = false,
}) {
  const { t } = useTranslation();

  return (
    <StyledEyeDiseaseTemplate $reverse={reverse}>
      <div className="container">
        <div className="eye-disease-temp__wrap">
          <div className="eye-disease-temp__left">
            <h1>{t(title)}</h1>
            <p>{t(text)}</p>
            <ul>
              {list.map((i) => (
                <li key={i}>
                  <IconWrapper
                    w={18}
                    h={18}
                    iconW={12}
                    iconH={12}
                    icon="check"
                  />
                  <p>{t(i)}</p>
                </li>
              ))}
            </ul>
            <div>
              <Link to="/contact" className="hover-underline">
                <p>Make an Appointment</p>
                <i className="icon icon-long-arrow-alt-right"></i>
              </Link>
            </div>
          </div>
          <div className="eye-disease-temp__right">
            <h1>{t(title)}</h1>
            <p>{t(text)}</p>
            <ul>
              {list.map((i) => (
                <li key={i}>
                  <IconWrapper
                    w={18}
                    h={18}
                    iconW={12}
                    iconH={12}
                    icon="check"
                  />
                  <p>{t(i)}</p>
                </li>
              ))}
            </ul>
            <div>
              <Link to="/contact" className="hover-underline">
                <p>{t("eyeDiseaseGetConsultationBtnText")}</p>
                <i className="icon icon-long-arrow-alt-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <ImageOverlayCard
        className="eye-disease-temp__img"
        image={img}
        title={t(title)}
        alt={t(title)}
      />
    </StyledEyeDiseaseTemplate>
  );
}

const StyledEyeDiseaseTemplate = styled.section`
  background-color: var(--white);
  padding: 140px 0;
  position: relative;

  .eye-disease-temp {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__left,
    &__right {
      h1 {
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 24px;
      }

      & > p {
        color: var(--text);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
        margin-bottom: 32px;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-bottom: 48px;

        li {
          display: flex;
          align-items: center;
          gap: 12px;

          p {
            color: var(--title);
            font-size: var(--fs-body-sm);
            font-style: normal;
            font-weight: var(--fw-medium);
            line-height: var(--lh-body);
          }
        }
      }

      a {
        display: flex;
        align-items: center;
        gap: 12px;
        width: max-content;

        p {
          color: var(--light-blue);
          font-size: var(--fs-body);
          font-style: normal;
          font-weight: var(--fw-medium);
          line-height: var(--lh-body);
        }

        i {
          width: 18px;
          height: 18px;
          background-color: var(--light-blue);
        }

        &::after {
          background-color: var(--light-blue);
        }

        &:hover {
          &::after {
            width: calc(100% - 30px);
          }

          i {
            transform: translateX(45px);
            opacity: 0;
          }
        }
      }
    }

    &__left {
      padding-right: 100px;
    }
    &__right {
      padding-left: 100px;
    }

    &__img {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;

      ${({ $reverse }) =>
        $reverse &&
        css`
          right: auto;
          left: 0;
        `}
    }
  }
`;
